const FIELD_MAPPING = {
  mfield_utopia_euro: 'EU',
  mfield_utopia_kids_us: 'US',
  mfield_utopia_kids_uk: 'UK',
  mfield_utopia_centimeter: 'CM'
}

export function getSizeType(field) {
  if (!field) return undefined
  const key = field.replace(/^variant_/, '')
  return (
    FIELD_MAPPING[field] ||
    FIELD_MAPPING[key] ||
    (key.includes('centimeter') && 'CM') ||
    (key.includes('euro') && 'EU') ||
    (key.includes('_us') && 'US') ||
    (key.includes('_uk') && 'UK') ||
    undefined
  )
}

export const sizeRanges = {
  '0-12 Months': [
    {
      UK: '01',
      EU: '17',
      US: '02'
    },
    {
      UK: '01.5',
      EU: '18',
      US: '02'
    },
    {
      UK: '02',
      EU: '18',
      US: '03'
    },
    {
      UK: '02.5',
      EU: '18',
      US: '03'
    },
    {
      UK: '03',
      EU: '19',
      US: '04'
    },
    {
      UK: '03.5',
      EU: '20',
      US: '05'
    },
    {
      UK: '04',
      EU: '20',
      US: '05'
    }
  ],
  '1-3 Years': [
    {
      UK: '04.5',
      EU: '21',
      US: '05'
    },
    {
      UK: '05',
      EU: '22',
      US: '06'
    },
    {
      UK: '05.5',
      EU: '22',
      US: '06'
    },
    {
      UK: '06',
      EU: '23',
      US: '07'
    },
    {
      UK: '06.5',
      EU: '23',
      US: '07'
    },
    {
      UK: '07',
      EU: '24',
      US: '08'
    },
    {
      UK: '07.5',
      EU: '24',
      US: '08'
    },
    {
      UK: '08',
      EU: '25',
      US: '09'
    },
    {
      UK: '08.5',
      EU: '26',
      US: '09'
    },
    {
      UK: '09',
      EU: '27',
      US: '010'
    },
    {
      UK: '09.5',
      EU: '27',
      US: '010'
    }
  ],
  '3-8 Years': [
    {
      UK: '010',
      EU: '28',
      US: '011'
    },
    {
      UK: '010.5',
      EU: '28',
      US: '011'
    },
    {
      UK: '011',
      EU: '29',
      US: '012'
    },
    {
      UK: '011.5',
      EU: '29',
      US: '012'
    },
    {
      UK: '012',
      EU: '30',
      US: '013'
    },
    {
      UK: '012.5',
      EU: '31',
      US: '013'
    },
    {
      UK: '013',
      EU: '32',
      US: '1'
    },
    {
      UK: '013.5',
      EU: '32',
      US: '1'
    },
    {
      UK: '1',
      EU: '33',
      US: '2'
    },
    {
      UK: '1.5',
      EU: '33',
      US: '2'
    }
  ],
  '8+ Years': [
    {
      UK: '2',
      EU: '34',
      US: '3'
    },
    {
      UK: '2.5',
      EU: '35',
      US: '3'
    },
    {
      UK: '3',
      EU: '36',
      US: '4'
    },
    {
      UK: '3.5',
      EU: '36',
      US: '4'
    },
    {
      UK: '4',
      EU: '37',
      US: '5'
    },
    {
      UK: '4.5',
      EU: '37',
      US: '5'
    },
    {
      UK: '5',
      EU: '38',
      US: '6'
    },
    {
      UK: '5.5',
      EU: '38',
      US: '6'
    },
    {
      UK: '6',
      EU: '39',
      US: '7'
    },
    {
      UK: '6.5',
      EU: '39',
      US: '7'
    },
    {
      UK: '7',
      EU: '40',
      US: '8'
    },
    {
      UK: '7.5',
      EU: '40',
      US: '8'
    }
  ],
  Adult: [
    {
      UK: '6',
      EU: '39.5',
      US: '8'
    },
    {
      UK: '7',
      EU: '40.5',
      US: '9'
    },
    {
      UK: '8',
      EU: '42',
      US: '10'
    }
  ]
}
